<button type="button" class="close-button" aria-label="Close" (click)="bsModalRef.hide()">
  <img src="assets/images/icons-new/close.svg" width="20" height="20" alt="" />
</button>
<h2 id="legacyRedirectLabel">Continue in the New Fair Supply Platform</h2>
<p>Your Fair Supply account has moved to our new platform. Continue there to access your account, data and the latest Fair Supply experience.</p>
<p>If you think you’re seeing this message by mistake, please <a href="mailto:support@fairsupply.com.au?subject=New%20Fair%20Supply%20Platform">contact us</a>.</p>
<footer>
  <a class="btn btn-outline" [href]="platformUrl">Open Platform</a>
</footer>
